// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"513":"2f8ba035","647":"8f42c708"}[chunkId] + ".css";
};